import { Box, Text } from '@mantine/core';
import { SuperUserOnly } from 'components/SuperUserOnly';
import { i18nKeys, useTranslation } from 'locales';

export const InvoiceLabel = () => {
  const { t } = useTranslation();

  return (
    <Box bg="purple.1" px={4} bdrs={6} w="fit-content">
      <Text size="sm" c="purple.5">
        {t(i18nKeys.COMMON.INVOICE)}
      </Text>
    </Box>
  );
};

export const CreditNoteLabel = () => {
  const { t } = useTranslation();

  return (
    <Box bg="red.1" px={4} bdrs={6} w="fit-content">
      <Text size="sm" c="red.5">
        {t(i18nKeys.CREDIT_NOTE_SHORT)}
      </Text>
    </Box>
  );
};

export const PaymentLabel = () => {
  const { t } = useTranslation();

  return (
    <Box bg="warning.1" px={4} bdrs={6} w="fit-content">
      <Text size="sm" c="warning.5">
        {t(i18nKeys.PAYMENT)}
      </Text>
    </Box>
  );
};

export const SuperadminLabel = () => {
  const { t } = useTranslation();

  return (
    <SuperUserOnly>
      <Box bg="red.1" px={4} bdrs={6} w="fit-content">
        <Text size="sm" c="red.5">
          {t(i18nKeys.SUPERADMIN.LABEL)}
        </Text>
      </Box>
    </SuperUserOnly>
  );
};
